// extracted by mini-css-extract-plugin
module.exports = {"embed-border":"FirstVideo_embed-border__3Qa_u","embed-responsive":"FirstVideo_embed-responsive__2Wvls","wrapper":"FirstVideo_wrapper__1jfQX"};